/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddTransferNoteRequestBody,
  Batch,
  ChangeTransferWorkflowRequestBody,
  ListBatchesResponseBody,
  ListDipsResponseBody,
  ListFileformatCategoryChangesResponseBody,
  ListPackageStatusUpdatesResponseBody,
  ListReingestRequestsResponseBody,
  ListTransferExceptionsResponseBody,
  ListTransferPackagesResponseBody,
  ListTransferReportsResponseBody,
  ListTransferSipsResponseBody,
  ListTransfersResponseBody,
  ListWorkflowDefinitionsResponseBody,
  Transfer,
  TransferNote,
} from '../models';
import {
    AddTransferNoteRequestBodyFromJSON,
    AddTransferNoteRequestBodyToJSON,
    BatchFromJSON,
    BatchToJSON,
    ChangeTransferWorkflowRequestBodyFromJSON,
    ChangeTransferWorkflowRequestBodyToJSON,
    ListBatchesResponseBodyFromJSON,
    ListBatchesResponseBodyToJSON,
    ListDipsResponseBodyFromJSON,
    ListDipsResponseBodyToJSON,
    ListFileformatCategoryChangesResponseBodyFromJSON,
    ListFileformatCategoryChangesResponseBodyToJSON,
    ListPackageStatusUpdatesResponseBodyFromJSON,
    ListPackageStatusUpdatesResponseBodyToJSON,
    ListReingestRequestsResponseBodyFromJSON,
    ListReingestRequestsResponseBodyToJSON,
    ListTransferExceptionsResponseBodyFromJSON,
    ListTransferExceptionsResponseBodyToJSON,
    ListTransferPackagesResponseBodyFromJSON,
    ListTransferPackagesResponseBodyToJSON,
    ListTransferReportsResponseBodyFromJSON,
    ListTransferReportsResponseBodyToJSON,
    ListTransferSipsResponseBodyFromJSON,
    ListTransferSipsResponseBodyToJSON,
    ListTransfersResponseBodyFromJSON,
    ListTransfersResponseBodyToJSON,
    ListWorkflowDefinitionsResponseBodyFromJSON,
    ListWorkflowDefinitionsResponseBodyToJSON,
    TransferFromJSON,
    TransferToJSON,
    TransferNoteFromJSON,
    TransferNoteToJSON,
} from '../models';

export interface ContentsAddTransferNoteRequest {
    id: string;
    addTransferNoteRequestBody: AddTransferNoteRequestBody;
}

export interface ContentsApproveTransferRequest {
    id: string;
}

export interface ContentsAuditRequest {
    activity: ContentsAuditActivityEnum;
}

export interface ContentsCancelTransferRequest {
    id: string;
}

export interface ContentsChangeTransferWorkflowRequest {
    id: string;
    changeTransferWorkflowRequestBody: ChangeTransferWorkflowRequestBody;
}

export interface ContentsDeleteTransferNoteRequest {
    id: string;
}

export interface ContentsDownloadTransferExceptionsReportRequest {
    id: string;
}

export interface ContentsDownloadTransferPackageRequest {
    id: string;
    packageId: string;
}

export interface ContentsDownloadTransferReportRequest {
    reportType: ContentsDownloadTransferReportReportTypeEnum;
    id: string;
}

export interface ContentsListBatchesRequest {
    name?: string;
    transferringAgency?: string;
    number?: string;
    contentType?: ContentsListBatchesContentTypeEnum;
    status?: ContentsListBatchesStatusEnum;
    statusUpdatedAt?: string;
    ordering?: ContentsListBatchesOrderingEnum;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListDipsRequest {
    id?: string;
    transferBatchNumber?: string;
    transferringAgency?: string;
    transferDate?: string;
    securityGrading?: ContentsListDipsSecurityGradingEnum;
    sensitivityClassification?: ContentsListDipsSensitivityClassificationEnum;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListDisseminationRequestsRequest {
    batchId?: number;
    packageType?: ContentsListDisseminationRequestsPackageTypeEnum;
    workflowId?: string;
    status?: ContentsListDisseminationRequestsStatusEnum;
    highestSecurityGrading?: string;
    highestSensitivityClassification?: string;
    createdAt?: Date;
    id?: number;
    packageId?: string;
    packageVersion?: number;
    ordering?: string;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListFileformatCategoryChangesRequest {
    batchId?: number;
    status?: ContentsListFileformatCategoryChangesStatusEnum;
    createdAt?: Date;
    location?: string;
    versionNumber?: number;
    ordering?: string;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListPackageStatusUpdatesRequest {
    id?: string;
    batchId?: number;
    status?: ContentsListPackageStatusUpdatesStatusEnum;
    createdAt?: Date;
    location?: string;
    numberOfUpdates?: number;
    ordering?: string;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListReingestRequestsRequest {
    batchId?: number;
    packageType?: ContentsListReingestRequestsPackageTypeEnum;
    workflowId?: string;
    status?: ContentsListReingestRequestsStatusEnum;
    highestSecurityGrading?: string;
    highestSensitivityClassification?: string;
    createdAt?: Date;
    id?: number;
    packageId?: string;
    packageVersion?: number;
    ordering?: string;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListTransferExceptionsRequest {
    id: string;
    type?: ContentsListTransferExceptionsTypeEnum;
    ordering?: string;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListTransferFilesRequest {
    id: string;
    path?: string;
}

export interface ContentsListTransferPackagesRequest {
    id: string;
    sipId?: string;
    packageId?: string;
    packageType?: ContentsListTransferPackagesPackageTypeEnum;
    status?: ContentsListTransferPackagesStatusEnum;
    ordering?: string;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListTransferReportsRequest {
    transferBatchNumber?: string;
    transferringAgency?: string;
    ordering?: string;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListTransferSipsRequest {
    id: string;
    name?: string;
    status?: ContentsListTransferSipsStatusEnum;
    ordering?: ContentsListTransferSipsOrderingEnum;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListTransfersRequest {
    batchId?: number;
    batchNumber?: string;
    name?: string;
    note?: string;
    transferringAgency?: string;
    status?: ContentsListTransfersStatusEnum;
    structureType?: ContentsListTransfersStructureTypeEnum;
    highestSecurityGrading?: string;
    highestSensitivityClassification?: string;
    workflowId?: string;
    totalBatchSize?: number;
    depositedAt?: Date;
    processingStartedAt?: Date;
    processingCompletedAt?: Date;
    sipCount?: number;
    fileCount?: number;
    ordering?: ContentsListTransfersOrderingEnum;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsListWorkflowDefinitionsRequest {
    batchId?: number;
    workflowType?: string;
    status?: ContentsListWorkflowDefinitionsStatusEnum;
    createdAt?: Date;
    definitionFile?: string;
    name?: string;
    versionNumber?: number;
    ordering?: string;
    limit?: number;
    offset?: number;
    startingAfter?: string;
}

export interface ContentsRecreateSipsRequest {
    id: string;
}

export interface ContentsRejectTransferRequest {
    id: string;
}

export interface ContentsResubmitTransferRequest {
    id: string;
}

export interface ContentsRetryTransferRequest {
    id: string;
}

export interface ContentsShowBatchRequest {
    id: number;
}

export interface ContentsShowTransferRequest {
    id: string;
}

export interface ContentsShowTransferNoteRequest {
    id: string;
}

/**
 * ContentsApi - interface
 * 
 * @export
 * @interface ContentsApiInterface
 */
export interface ContentsApiInterface {
    /**
     * Add a note to a Transfer
     * @summary add_transfer_note contents
     * @param {string} id Identifier of transfer to add note to
     * @param {AddTransferNoteRequestBody} addTransferNoteRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsAddTransferNoteRaw(requestParameters: ContentsAddTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Add a note to a Transfer
     * add_transfer_note contents
     */
    contentsAddTransferNote(requestParameters: ContentsAddTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Signal the transfer has been reviewed and approved
     * @summary approve_transfer contents
     * @param {string} id Identifier of transfer to approve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsApproveTransferRaw(requestParameters: ContentsApproveTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Signal the transfer has been reviewed and approved
     * approve_transfer contents
     */
    contentsApproveTransfer(requestParameters: ContentsApproveTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Send information for user activity audit logs
     * @summary audit contents
     * @param {'Login' | 'Logout' | 'Transfer Report Unknown' | 'Transfer Report Summary'} activity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsAuditRaw(requestParameters: ContentsAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Send information for user activity audit logs
     * audit contents
     */
    contentsAudit(requestParameters: ContentsAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Fails a Transfer
     * @summary cancel_transfer contents
     * @param {string} id Identifier of transfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsCancelTransferRaw(requestParameters: ContentsCancelTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Fails a Transfer
     * cancel_transfer contents
     */
    contentsCancelTransfer(requestParameters: ContentsCancelTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Signal to assign a new workflow to a transfer.
     * @summary change_transfer_workflow contents
     * @param {string} id Identifier of transfer
     * @param {ChangeTransferWorkflowRequestBody} changeTransferWorkflowRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsChangeTransferWorkflowRaw(requestParameters: ContentsChangeTransferWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Signal to assign a new workflow to a transfer.
     * change_transfer_workflow contents
     */
    contentsChangeTransferWorkflow(requestParameters: ContentsChangeTransferWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Delete the note from a transfer
     * @summary delete_transfer_note contents
     * @param {string} id Identifier of transfer to delete note from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsDeleteTransferNoteRaw(requestParameters: ContentsDeleteTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the note from a transfer
     * delete_transfer_note contents
     */
    contentsDeleteTransferNote(requestParameters: ContentsDeleteTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Get a CSV report with errors and warnings related to a given transfer
     * @summary download_transfer_exceptions_report contents
     * @param {string} id Identifier of transfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsDownloadTransferExceptionsReportRaw(requestParameters: ContentsDownloadTransferExceptionsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Get a CSV report with errors and warnings related to a given transfer
     * download_transfer_exceptions_report contents
     */
    contentsDownloadTransferExceptionsReport(requestParameters: ContentsDownloadTransferExceptionsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Download a package related to a given transfer (only DIPs are supported at this point)
     * @summary download_transfer_package contents
     * @param {string} id Identifier of transfer
     * @param {string} packageId Identifier of package
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsDownloadTransferPackageRaw(requestParameters: ContentsDownloadTransferPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Download a package related to a given transfer (only DIPs are supported at this point)
     * download_transfer_package contents
     */
    contentsDownloadTransferPackage(requestParameters: ContentsDownloadTransferPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Download transfer report.
     * @summary download_transfer_report contents
     * @param {'summary' | 'appendix'} reportType Type of the report
     * @param {string} id Identifier of transfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsDownloadTransferReportRaw(requestParameters: ContentsDownloadTransferReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Download transfer report.
     * download_transfer_report contents
     */
    contentsDownloadTransferReport(requestParameters: ContentsDownloadTransferReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * List all known batches.
     * @summary list_batches contents
     * @param {string} [name] 
     * @param {string} [transferringAgency] Name of the Agency that transferred the batch to SDPS
     * @param {string} [number] 
     * @param {'Transfer' | 'SIP' | 'AIP' | 'DIP' | 'Package Status Updates' | 'Workflow Definition' | 'Dissemination Request' | 'Reingest Request' | 'File Format Category Changes' | 'Unknown' | 'System Configuration Updates'} [contentType] 
     * @param {'Received' | 'Accepted' | 'Failed' | 'Identified'} [status] 
     * @param {string} [statusUpdatedAt] Timestamp of the latest status update. It expects Unix time. Date ranges are exclusive.
     * @param {'id' | 'content_type' | 'time_started' | 'status_updated_at' | 'status' | 'd-id' | 'd-content_type' | 'd-time_started' | 'd-status_updated_at' | 'd-status'} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListBatchesRaw(requestParameters: ContentsListBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBatchesResponseBody>>;

    /**
     * List all known batches.
     * list_batches contents
     */
    contentsListBatches(requestParameters: ContentsListBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBatchesResponseBody>;

    /**
     * List all known DIPs
     * @summary list_dips contents
     * @param {string} [id] Identifier of DIP
     * @param {string} [transferBatchNumber] Transfer batch number
     * @param {string} [transferringAgency] Transferring agency
     * @param {string} [transferDate] Timestamp of the transfer. It expects Unix time. Date ranges are exclusive.
     * @param {'Confidential' | 'Confidential (Cloud-Eligible)' | 'Restricted' | 'Official (Closed)' | 'Official (Open)' | 'Secret' | 'Unclassified' | 'Undefined'} [securityGrading] Security grading
     * @param {'Undefined' | 'Non-Sensitive' | 'Sensitive Normal' | 'Sensitive High'} [sensitivityClassification] Sensitivity classification
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListDipsRaw(requestParameters: ContentsListDipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDipsResponseBody>>;

    /**
     * List all known DIPs
     * list_dips contents
     */
    contentsListDips(requestParameters: ContentsListDipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDipsResponseBody>;

    /**
     * list all known packages submitted to isolated zone for dissemination
     * @summary list_dissemination_requests contents
     * @param {number} [batchId] parent batch of this dissemination request
     * @param {'AIP' | 'DIP'} [packageType] 
     * @param {string} [workflowId] ID of workflow selected for Dissemination
     * @param {'Received' | 'Validated' | 'Failed' | 'In Progress' | 'Rejected' | 'Completed'} [status] 
     * @param {string} [highestSecurityGrading] Highest security grade of any content in the package
     * @param {string} [highestSensitivityClassification] Highest sensisivity classification of any content in the package
     * @param {Date} [createdAt] 
     * @param {number} [id] Identifier of dissemination request
     * @param {string} [packageId] Identifier of package
     * @param {number} [packageVersion] 
     * @param {string} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListDisseminationRequestsRaw(requestParameters: ContentsListDisseminationRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListReingestRequestsResponseBody>>;

    /**
     * list all known packages submitted to isolated zone for dissemination
     * list_dissemination_requests contents
     */
    contentsListDisseminationRequests(requestParameters: ContentsListDisseminationRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListReingestRequestsResponseBody>;

    /**
     * list all known file format category changes submitted to isolateed zone
     * @summary list_fileformat_category_changes contents
     * @param {number} [batchId] Parent Batch of this fileformat category change
     * @param {'Received' | 'Validated' | 'Failed' | 'In Progress' | 'Rejected' | 'Completed'} [status] 
     * @param {Date} [createdAt] 
     * @param {string} [location] 
     * @param {number} [versionNumber] 
     * @param {string} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListFileformatCategoryChangesRaw(requestParameters: ContentsListFileformatCategoryChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListFileformatCategoryChangesResponseBody>>;

    /**
     * list all known file format category changes submitted to isolateed zone
     * list_fileformat_category_changes contents
     */
    contentsListFileformatCategoryChanges(requestParameters: ContentsListFileformatCategoryChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListFileformatCategoryChangesResponseBody>;

    /**
     * list all known package status updates submitted to isolateed zone
     * @summary list_package_status_updates contents
     * @param {string} [id] Identifier of PSU
     * @param {number} [batchId] Parent batch of this PSU
     * @param {'Received' | 'Validated' | 'Failed' | 'In Progress' | 'Rejected' | 'Completed'} [status] 
     * @param {Date} [createdAt] 
     * @param {string} [location] 
     * @param {number} [numberOfUpdates] 
     * @param {string} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListPackageStatusUpdatesRaw(requestParameters: ContentsListPackageStatusUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPackageStatusUpdatesResponseBody>>;

    /**
     * list all known package status updates submitted to isolateed zone
     * list_package_status_updates contents
     */
    contentsListPackageStatusUpdates(requestParameters: ContentsListPackageStatusUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPackageStatusUpdatesResponseBody>;

    /**
     * list all known packages submitted to isolated zone for reingest
     * @summary list_reingest_requests contents
     * @param {number} [batchId] parent batch of this reingest request
     * @param {'AIP' | 'DIP'} [packageType] 
     * @param {string} [workflowId] ID of workflow selected for Reingest
     * @param {'Received' | 'Validated' | 'Failed' | 'In Progress' | 'Rejected' | 'Completed'} [status] 
     * @param {string} [highestSecurityGrading] Highest security grade of any content in the package
     * @param {string} [highestSensitivityClassification] Highest sensisivity classification of any content in the package
     * @param {Date} [createdAt] 
     * @param {number} [id] Identifier of reingest request
     * @param {string} [packageId] Identifier of package
     * @param {number} [packageVersion] 
     * @param {string} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListReingestRequestsRaw(requestParameters: ContentsListReingestRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListReingestRequestsResponseBody>>;

    /**
     * list all known packages submitted to isolated zone for reingest
     * list_reingest_requests contents
     */
    contentsListReingestRequests(requestParameters: ContentsListReingestRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListReingestRequestsResponseBody>;

    /**
     * Get errors and warnings related to a given transfer
     * @summary list_transfer_exceptions contents
     * @param {string} id Identifier of transfer
     * @param {'Warning' | 'Critical Error' | 'Non-critical Error'} [type] 
     * @param {string} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListTransferExceptionsRaw(requestParameters: ContentsListTransferExceptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransferExceptionsResponseBody>>;

    /**
     * Get errors and warnings related to a given transfer
     * list_transfer_exceptions contents
     */
    contentsListTransferExceptions(requestParameters: ContentsListTransferExceptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransferExceptionsResponseBody>;

    /**
     * Get a collection of files related to a given transfer
     * @summary list_transfer_files contents
     * @param {string} id Identifier of transfer
     * @param {string} [path] Path within the transfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListTransferFilesRaw(requestParameters: ContentsListTransferFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>>;

    /**
     * Get a collection of files related to a given transfer
     * list_transfer_files contents
     */
    contentsListTransferFiles(requestParameters: ContentsListTransferFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>>;

    /**
     * Get a collection of AIPs and DIPs related to a given transfer
     * @summary list_transfer_packages contents
     * @param {string} id Identifier of transfer
     * @param {string} [sipId] Identifier of related SIP
     * @param {string} [packageId] Identifier of package
     * @param {'AIP' | 'DIP'} [packageType] 
     * @param {'Created' | 'Validated' | 'Failed' | 'Sent to Storage' | 'Stored' | 'Dissemination Requested' | 'Disseminated' | 'Reingest Requested' | 'Pre-Processing' | 'Ready for Ingest' | 'Ingesting' | 'Pending Review' | 'Rejected'} [status] 
     * @param {string} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListTransferPackagesRaw(requestParameters: ContentsListTransferPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransferPackagesResponseBody>>;

    /**
     * Get a collection of AIPs and DIPs related to a given transfer
     * list_transfer_packages contents
     */
    contentsListTransferPackages(requestParameters: ContentsListTransferPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransferPackagesResponseBody>;

    /**
     * List transfer summary reports
     * @summary list_transfer_reports contents
     * @param {string} [transferBatchNumber] Transfer batch number
     * @param {string} [transferringAgency] Transferring agency
     * @param {string} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListTransferReportsRaw(requestParameters: ContentsListTransferReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransferReportsResponseBody>>;

    /**
     * List transfer summary reports
     * list_transfer_reports contents
     */
    contentsListTransferReports(requestParameters: ContentsListTransferReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransferReportsResponseBody>;

    /**
     * Get a collection of SIPs related to a given transfer
     * @summary list_transfer_sips contents
     * @param {string} id Identifier of transfer
     * @param {string} [name] 
     * @param {'Created' | 'Failed' | 'Ingesting' | 'Packages Created' | 'Rejected' | 'Stored'} [status] 
     * @param {'sip_id' | 'name' | 'status' | 'status_updated_at' | 'd-sip_id' | 'd-name' | 'd-status' | 'd-status_updated_at'} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListTransferSipsRaw(requestParameters: ContentsListTransferSipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransferSipsResponseBody>>;

    /**
     * Get a collection of SIPs related to a given transfer
     * list_transfer_sips contents
     */
    contentsListTransferSips(requestParameters: ContentsListTransferSipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransferSipsResponseBody>;

    /**
     * List all known transfers
     * @summary list_transfers contents
     * @param {number} [batchId] Parent Batch of the transfer
     * @param {string} [batchNumber] Batch number
     * @param {string} [name] 
     * @param {string} [note] 
     * @param {string} [transferringAgency] 
     * @param {'Received' | 'Failed' | 'Pre-Processing' | 'Pending Review' | 'Rejected' | 'Ready for Ingest' | 'Ingesting' | 'Packages Created' | 'Packages Sent to Storage' | 'Stored' | 'Report Created' | 'SIP Creation Failed'} [status] 
     * @param {'EAS A' | 'EAS B' | 'EAS D-1' | 'Bag'} [structureType] 
     * @param {string} [highestSecurityGrading] 
     * @param {string} [highestSensitivityClassification] 
     * @param {string} [workflowId] 
     * @param {number} [totalBatchSize] 
     * @param {Date} [depositedAt] 
     * @param {Date} [processingStartedAt] 
     * @param {Date} [processingCompletedAt] 
     * @param {number} [sipCount] 
     * @param {number} [fileCount] 
     * @param {'processing_started_at' | 'd-processing_started_at'} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListTransfersRaw(requestParameters: ContentsListTransfersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransfersResponseBody>>;

    /**
     * List all known transfers
     * list_transfers contents
     */
    contentsListTransfers(requestParameters: ContentsListTransfersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransfersResponseBody>;

    /**
     * list all known workflow definitions submitted to isolateed zone
     * @summary list_workflow_definitions contents
     * @param {number} [batchId] parent batch of this workflow definition
     * @param {string} [workflowType] 
     * @param {'Received' | 'Validated' | 'Failed' | 'In Progress' | 'Rejected' | 'Completed'} [status] 
     * @param {Date} [createdAt] 
     * @param {string} [definitionFile] location/path of workflow definition file
     * @param {string} [name] 
     * @param {number} [versionNumber] 
     * @param {string} [ordering] Name(s) of the field(s) to sort on.
     * @param {number} [limit] A limit on the number of objects to be returned, between 1 and 1000.
     * @param {number} [offset] An offset for use in pagination, takes preference over starting_after.
     * @param {string} [startingAfter] A cursor for use in pagination.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsListWorkflowDefinitionsRaw(requestParameters: ContentsListWorkflowDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWorkflowDefinitionsResponseBody>>;

    /**
     * list all known workflow definitions submitted to isolateed zone
     * list_workflow_definitions contents
     */
    contentsListWorkflowDefinitions(requestParameters: ContentsListWorkflowDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWorkflowDefinitionsResponseBody>;

    /**
     * Recreate all SIPs in a transfer
     * @summary recreate_sips contents
     * @param {string} id Identifier of transfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsRecreateSipsRaw(requestParameters: ContentsRecreateSipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Recreate all SIPs in a transfer
     * recreate_sips contents
     */
    contentsRecreateSips(requestParameters: ContentsRecreateSipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Signal the transfer has been reviewed and rejected
     * @summary reject_transfer contents
     * @param {string} id Identifier of transfer to reject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsRejectTransferRaw(requestParameters: ContentsRejectTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Signal the transfer has been reviewed and rejected
     * reject_transfer contents
     */
    contentsRejectTransfer(requestParameters: ContentsRejectTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Resubmit all SIPs in a transfer
     * @summary resubmit_transfer contents
     * @param {string} id Identifier of transfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsResubmitTransferRaw(requestParameters: ContentsResubmitTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Resubmit all SIPs in a transfer
     * resubmit_transfer contents
     */
    contentsResubmitTransfer(requestParameters: ContentsResubmitTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Signal the transfer has been reviewed and should be resubmitted to the SDPS.
     * @summary retry_transfer contents
     * @param {string} id Identifier of transfer to retry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsRetryTransferRaw(requestParameters: ContentsRetryTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Signal the transfer has been reviewed and should be resubmitted to the SDPS.
     * retry_transfer contents
     */
    contentsRetryTransfer(requestParameters: ContentsRetryTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Show batch by ID
     * @summary show_batch contents
     * @param {number} id Identifier of batch to show
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsShowBatchRaw(requestParameters: ContentsShowBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Batch>>;

    /**
     * Show batch by ID
     * show_batch contents
     */
    contentsShowBatch(requestParameters: ContentsShowBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Batch>;

    /**
     * Show transfer by ID
     * @summary show_transfer contents
     * @param {string} id Identifier of transfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsShowTransferRaw(requestParameters: ContentsShowTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Transfer>>;

    /**
     * Show transfer by ID
     * show_transfer contents
     */
    contentsShowTransfer(requestParameters: ContentsShowTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Transfer>;

    /**
     * Show note for a transfer
     * @summary show_transfer_note contents
     * @param {string} id Identifier of transfer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentsApiInterface
     */
    contentsShowTransferNoteRaw(requestParameters: ContentsShowTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransferNote>>;

    /**
     * Show note for a transfer
     * show_transfer_note contents
     */
    contentsShowTransferNote(requestParameters: ContentsShowTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransferNote>;

}

/**
 * 
 */
export class ContentsApi extends runtime.BaseAPI implements ContentsApiInterface {

    /**
     * Add a note to a Transfer
     * add_transfer_note contents
     */
    async contentsAddTransferNoteRaw(requestParameters: ContentsAddTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsAddTransferNote.');
        }

        if (requestParameters.addTransferNoteRequestBody === null || requestParameters.addTransferNoteRequestBody === undefined) {
            throw new runtime.RequiredError('addTransferNoteRequestBody','Required parameter requestParameters.addTransferNoteRequestBody was null or undefined when calling contentsAddTransferNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/note`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddTransferNoteRequestBodyToJSON(requestParameters.addTransferNoteRequestBody),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a note to a Transfer
     * add_transfer_note contents
     */
    async contentsAddTransferNote(requestParameters: ContentsAddTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsAddTransferNoteRaw(requestParameters, initOverrides);
    }

    /**
     * Signal the transfer has been reviewed and approved
     * approve_transfer contents
     */
    async contentsApproveTransferRaw(requestParameters: ContentsApproveTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsApproveTransfer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/approve`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Signal the transfer has been reviewed and approved
     * approve_transfer contents
     */
    async contentsApproveTransfer(requestParameters: ContentsApproveTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsApproveTransferRaw(requestParameters, initOverrides);
    }

    /**
     * Send information for user activity audit logs
     * audit contents
     */
    async contentsAuditRaw(requestParameters: ContentsAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.activity === null || requestParameters.activity === undefined) {
            throw new runtime.RequiredError('activity','Required parameter requestParameters.activity was null or undefined when calling contentsAudit.');
        }

        const queryParameters: any = {};

        if (requestParameters.activity !== undefined) {
            queryParameters['activity'] = requestParameters.activity;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/audit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Send information for user activity audit logs
     * audit contents
     */
    async contentsAudit(requestParameters: ContentsAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsAuditRaw(requestParameters, initOverrides);
    }

    /**
     * Fails a Transfer
     * cancel_transfer contents
     */
    async contentsCancelTransferRaw(requestParameters: ContentsCancelTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsCancelTransfer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/cancel`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Fails a Transfer
     * cancel_transfer contents
     */
    async contentsCancelTransfer(requestParameters: ContentsCancelTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsCancelTransferRaw(requestParameters, initOverrides);
    }

    /**
     * Signal to assign a new workflow to a transfer.
     * change_transfer_workflow contents
     */
    async contentsChangeTransferWorkflowRaw(requestParameters: ContentsChangeTransferWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsChangeTransferWorkflow.');
        }

        if (requestParameters.changeTransferWorkflowRequestBody === null || requestParameters.changeTransferWorkflowRequestBody === undefined) {
            throw new runtime.RequiredError('changeTransferWorkflowRequestBody','Required parameter requestParameters.changeTransferWorkflowRequestBody was null or undefined when calling contentsChangeTransferWorkflow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/workflow`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeTransferWorkflowRequestBodyToJSON(requestParameters.changeTransferWorkflowRequestBody),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Signal to assign a new workflow to a transfer.
     * change_transfer_workflow contents
     */
    async contentsChangeTransferWorkflow(requestParameters: ContentsChangeTransferWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsChangeTransferWorkflowRaw(requestParameters, initOverrides);
    }

    /**
     * Delete the note from a transfer
     * delete_transfer_note contents
     */
    async contentsDeleteTransferNoteRaw(requestParameters: ContentsDeleteTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsDeleteTransferNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/note`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the note from a transfer
     * delete_transfer_note contents
     */
    async contentsDeleteTransferNote(requestParameters: ContentsDeleteTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsDeleteTransferNoteRaw(requestParameters, initOverrides);
    }

    /**
     * Get a CSV report with errors and warnings related to a given transfer
     * download_transfer_exceptions_report contents
     */
    async contentsDownloadTransferExceptionsReportRaw(requestParameters: ContentsDownloadTransferExceptionsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsDownloadTransferExceptionsReport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/exceptions/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Get a CSV report with errors and warnings related to a given transfer
     * download_transfer_exceptions_report contents
     */
    async contentsDownloadTransferExceptionsReport(requestParameters: ContentsDownloadTransferExceptionsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.contentsDownloadTransferExceptionsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download a package related to a given transfer (only DIPs are supported at this point)
     * download_transfer_package contents
     */
    async contentsDownloadTransferPackageRaw(requestParameters: ContentsDownloadTransferPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsDownloadTransferPackage.');
        }

        if (requestParameters.packageId === null || requestParameters.packageId === undefined) {
            throw new runtime.RequiredError('packageId','Required parameter requestParameters.packageId was null or undefined when calling contentsDownloadTransferPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/packages/{package_id}/download`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"package_id"}}`, encodeURIComponent(String(requestParameters.packageId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download a package related to a given transfer (only DIPs are supported at this point)
     * download_transfer_package contents
     */
    async contentsDownloadTransferPackage(requestParameters: ContentsDownloadTransferPackageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.contentsDownloadTransferPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download transfer report.
     * download_transfer_report contents
     */
    async contentsDownloadTransferReportRaw(requestParameters: ContentsDownloadTransferReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.reportType === null || requestParameters.reportType === undefined) {
            throw new runtime.RequiredError('reportType','Required parameter requestParameters.reportType was null or undefined when calling contentsDownloadTransferReport.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsDownloadTransferReport.');
        }

        const queryParameters: any = {};

        if (requestParameters.reportType !== undefined) {
            queryParameters['report_type'] = requestParameters.reportType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/report`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download transfer report.
     * download_transfer_report contents
     */
    async contentsDownloadTransferReport(requestParameters: ContentsDownloadTransferReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.contentsDownloadTransferReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all known batches.
     * list_batches contents
     */
    async contentsListBatchesRaw(requestParameters: ContentsListBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListBatchesResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.transferringAgency !== undefined) {
            queryParameters['transferring_agency'] = requestParameters.transferringAgency;
        }

        if (requestParameters.number !== undefined) {
            queryParameters['number'] = requestParameters.number;
        }

        if (requestParameters.contentType !== undefined) {
            queryParameters['content_type'] = requestParameters.contentType;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.statusUpdatedAt !== undefined) {
            queryParameters['status_updated_at'] = requestParameters.statusUpdatedAt;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/batches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListBatchesResponseBodyFromJSON(jsonValue));
    }

    /**
     * List all known batches.
     * list_batches contents
     */
    async contentsListBatches(requestParameters: ContentsListBatchesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListBatchesResponseBody> {
        const response = await this.contentsListBatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all known DIPs
     * list_dips contents
     */
    async contentsListDipsRaw(requestParameters: ContentsListDipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDipsResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.transferBatchNumber !== undefined) {
            queryParameters['transfer_batch_number'] = requestParameters.transferBatchNumber;
        }

        if (requestParameters.transferringAgency !== undefined) {
            queryParameters['transferring_agency'] = requestParameters.transferringAgency;
        }

        if (requestParameters.transferDate !== undefined) {
            queryParameters['transfer_date'] = requestParameters.transferDate;
        }

        if (requestParameters.securityGrading !== undefined) {
            queryParameters['security_grading'] = requestParameters.securityGrading;
        }

        if (requestParameters.sensitivityClassification !== undefined) {
            queryParameters['sensitivity_classification'] = requestParameters.sensitivityClassification;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/packages/dips`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDipsResponseBodyFromJSON(jsonValue));
    }

    /**
     * List all known DIPs
     * list_dips contents
     */
    async contentsListDips(requestParameters: ContentsListDipsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDipsResponseBody> {
        const response = await this.contentsListDipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * list all known packages submitted to isolated zone for dissemination
     * list_dissemination_requests contents
     */
    async contentsListDisseminationRequestsRaw(requestParameters: ContentsListDisseminationRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListReingestRequestsResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.batchId !== undefined) {
            queryParameters['batch_id'] = requestParameters.batchId;
        }

        if (requestParameters.packageType !== undefined) {
            queryParameters['package_type'] = requestParameters.packageType;
        }

        if (requestParameters.workflowId !== undefined) {
            queryParameters['workflow_id'] = requestParameters.workflowId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.highestSecurityGrading !== undefined) {
            queryParameters['highest_security_grading'] = requestParameters.highestSecurityGrading;
        }

        if (requestParameters.highestSensitivityClassification !== undefined) {
            queryParameters['highest_sensitivity_classification'] = requestParameters.highestSensitivityClassification;
        }

        if (requestParameters.createdAt !== undefined) {
            queryParameters['created_at'] = (requestParameters.createdAt as any).toISOString();
        }

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.packageId !== undefined) {
            queryParameters['package_id'] = requestParameters.packageId;
        }

        if (requestParameters.packageVersion !== undefined) {
            queryParameters['package_version'] = requestParameters.packageVersion;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/dissemination-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListReingestRequestsResponseBodyFromJSON(jsonValue));
    }

    /**
     * list all known packages submitted to isolated zone for dissemination
     * list_dissemination_requests contents
     */
    async contentsListDisseminationRequests(requestParameters: ContentsListDisseminationRequestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListReingestRequestsResponseBody> {
        const response = await this.contentsListDisseminationRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * list all known file format category changes submitted to isolateed zone
     * list_fileformat_category_changes contents
     */
    async contentsListFileformatCategoryChangesRaw(requestParameters: ContentsListFileformatCategoryChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListFileformatCategoryChangesResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.batchId !== undefined) {
            queryParameters['batch_id'] = requestParameters.batchId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.createdAt !== undefined) {
            queryParameters['created_at'] = (requestParameters.createdAt as any).toISOString();
        }

        if (requestParameters.location !== undefined) {
            queryParameters['location'] = requestParameters.location;
        }

        if (requestParameters.versionNumber !== undefined) {
            queryParameters['version_number'] = requestParameters.versionNumber;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/fileformat-category-changes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListFileformatCategoryChangesResponseBodyFromJSON(jsonValue));
    }

    /**
     * list all known file format category changes submitted to isolateed zone
     * list_fileformat_category_changes contents
     */
    async contentsListFileformatCategoryChanges(requestParameters: ContentsListFileformatCategoryChangesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListFileformatCategoryChangesResponseBody> {
        const response = await this.contentsListFileformatCategoryChangesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * list all known package status updates submitted to isolateed zone
     * list_package_status_updates contents
     */
    async contentsListPackageStatusUpdatesRaw(requestParameters: ContentsListPackageStatusUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPackageStatusUpdatesResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.batchId !== undefined) {
            queryParameters['batch_id'] = requestParameters.batchId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.createdAt !== undefined) {
            queryParameters['created_at'] = (requestParameters.createdAt as any).toISOString();
        }

        if (requestParameters.location !== undefined) {
            queryParameters['location'] = requestParameters.location;
        }

        if (requestParameters.numberOfUpdates !== undefined) {
            queryParameters['number_of_updates'] = requestParameters.numberOfUpdates;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/package-status-updates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPackageStatusUpdatesResponseBodyFromJSON(jsonValue));
    }

    /**
     * list all known package status updates submitted to isolateed zone
     * list_package_status_updates contents
     */
    async contentsListPackageStatusUpdates(requestParameters: ContentsListPackageStatusUpdatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPackageStatusUpdatesResponseBody> {
        const response = await this.contentsListPackageStatusUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * list all known packages submitted to isolated zone for reingest
     * list_reingest_requests contents
     */
    async contentsListReingestRequestsRaw(requestParameters: ContentsListReingestRequestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListReingestRequestsResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.batchId !== undefined) {
            queryParameters['batch_id'] = requestParameters.batchId;
        }

        if (requestParameters.packageType !== undefined) {
            queryParameters['package_type'] = requestParameters.packageType;
        }

        if (requestParameters.workflowId !== undefined) {
            queryParameters['workflow_id'] = requestParameters.workflowId;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.highestSecurityGrading !== undefined) {
            queryParameters['highest_security_grading'] = requestParameters.highestSecurityGrading;
        }

        if (requestParameters.highestSensitivityClassification !== undefined) {
            queryParameters['highest_sensitivity_classification'] = requestParameters.highestSensitivityClassification;
        }

        if (requestParameters.createdAt !== undefined) {
            queryParameters['created_at'] = (requestParameters.createdAt as any).toISOString();
        }

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.packageId !== undefined) {
            queryParameters['package_id'] = requestParameters.packageId;
        }

        if (requestParameters.packageVersion !== undefined) {
            queryParameters['package_version'] = requestParameters.packageVersion;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/reingest-requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListReingestRequestsResponseBodyFromJSON(jsonValue));
    }

    /**
     * list all known packages submitted to isolated zone for reingest
     * list_reingest_requests contents
     */
    async contentsListReingestRequests(requestParameters: ContentsListReingestRequestsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListReingestRequestsResponseBody> {
        const response = await this.contentsListReingestRequestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get errors and warnings related to a given transfer
     * list_transfer_exceptions contents
     */
    async contentsListTransferExceptionsRaw(requestParameters: ContentsListTransferExceptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransferExceptionsResponseBody>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsListTransferExceptions.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/exceptions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTransferExceptionsResponseBodyFromJSON(jsonValue));
    }

    /**
     * Get errors and warnings related to a given transfer
     * list_transfer_exceptions contents
     */
    async contentsListTransferExceptions(requestParameters: ContentsListTransferExceptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransferExceptionsResponseBody> {
        const response = await this.contentsListTransferExceptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a collection of files related to a given transfer
     * list_transfer_files contents
     */
    async contentsListTransferFilesRaw(requestParameters: ContentsListTransferFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<any>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsListTransferFiles.');
        }

        const queryParameters: any = {};

        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/files`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get a collection of files related to a given transfer
     * list_transfer_files contents
     */
    async contentsListTransferFiles(requestParameters: ContentsListTransferFilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<any>> {
        const response = await this.contentsListTransferFilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a collection of AIPs and DIPs related to a given transfer
     * list_transfer_packages contents
     */
    async contentsListTransferPackagesRaw(requestParameters: ContentsListTransferPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransferPackagesResponseBody>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsListTransferPackages.');
        }

        const queryParameters: any = {};

        if (requestParameters.sipId !== undefined) {
            queryParameters['sip_id'] = requestParameters.sipId;
        }

        if (requestParameters.packageId !== undefined) {
            queryParameters['package_id'] = requestParameters.packageId;
        }

        if (requestParameters.packageType !== undefined) {
            queryParameters['package_type'] = requestParameters.packageType;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/packages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTransferPackagesResponseBodyFromJSON(jsonValue));
    }

    /**
     * Get a collection of AIPs and DIPs related to a given transfer
     * list_transfer_packages contents
     */
    async contentsListTransferPackages(requestParameters: ContentsListTransferPackagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransferPackagesResponseBody> {
        const response = await this.contentsListTransferPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List transfer summary reports
     * list_transfer_reports contents
     */
    async contentsListTransferReportsRaw(requestParameters: ContentsListTransferReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransferReportsResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.transferBatchNumber !== undefined) {
            queryParameters['transfer_batch_number'] = requestParameters.transferBatchNumber;
        }

        if (requestParameters.transferringAgency !== undefined) {
            queryParameters['transferring_agency'] = requestParameters.transferringAgency;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/reports`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTransferReportsResponseBodyFromJSON(jsonValue));
    }

    /**
     * List transfer summary reports
     * list_transfer_reports contents
     */
    async contentsListTransferReports(requestParameters: ContentsListTransferReportsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransferReportsResponseBody> {
        const response = await this.contentsListTransferReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a collection of SIPs related to a given transfer
     * list_transfer_sips contents
     */
    async contentsListTransferSipsRaw(requestParameters: ContentsListTransferSipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransferSipsResponseBody>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsListTransferSips.');
        }

        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/sips`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTransferSipsResponseBodyFromJSON(jsonValue));
    }

    /**
     * Get a collection of SIPs related to a given transfer
     * list_transfer_sips contents
     */
    async contentsListTransferSips(requestParameters: ContentsListTransferSipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransferSipsResponseBody> {
        const response = await this.contentsListTransferSipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all known transfers
     * list_transfers contents
     */
    async contentsListTransfersRaw(requestParameters: ContentsListTransfersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTransfersResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.batchId !== undefined) {
            queryParameters['batch_id'] = requestParameters.batchId;
        }

        if (requestParameters.batchNumber !== undefined) {
            queryParameters['batch_number'] = requestParameters.batchNumber;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.note !== undefined) {
            queryParameters['note'] = requestParameters.note;
        }

        if (requestParameters.transferringAgency !== undefined) {
            queryParameters['transferring_agency'] = requestParameters.transferringAgency;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.structureType !== undefined) {
            queryParameters['structure_type'] = requestParameters.structureType;
        }

        if (requestParameters.highestSecurityGrading !== undefined) {
            queryParameters['highest_security_grading'] = requestParameters.highestSecurityGrading;
        }

        if (requestParameters.highestSensitivityClassification !== undefined) {
            queryParameters['highest_sensitivity_classification'] = requestParameters.highestSensitivityClassification;
        }

        if (requestParameters.workflowId !== undefined) {
            queryParameters['workflow_id'] = requestParameters.workflowId;
        }

        if (requestParameters.totalBatchSize !== undefined) {
            queryParameters['total_batch_size'] = requestParameters.totalBatchSize;
        }

        if (requestParameters.depositedAt !== undefined) {
            queryParameters['deposited_at'] = (requestParameters.depositedAt as any).toISOString();
        }

        if (requestParameters.processingStartedAt !== undefined) {
            queryParameters['processing_started_at'] = (requestParameters.processingStartedAt as any).toISOString();
        }

        if (requestParameters.processingCompletedAt !== undefined) {
            queryParameters['processing_completed_at'] = (requestParameters.processingCompletedAt as any).toISOString();
        }

        if (requestParameters.sipCount !== undefined) {
            queryParameters['sip_count'] = requestParameters.sipCount;
        }

        if (requestParameters.fileCount !== undefined) {
            queryParameters['file_count'] = requestParameters.fileCount;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTransfersResponseBodyFromJSON(jsonValue));
    }

    /**
     * List all known transfers
     * list_transfers contents
     */
    async contentsListTransfers(requestParameters: ContentsListTransfersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTransfersResponseBody> {
        const response = await this.contentsListTransfersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * list all known workflow definitions submitted to isolateed zone
     * list_workflow_definitions contents
     */
    async contentsListWorkflowDefinitionsRaw(requestParameters: ContentsListWorkflowDefinitionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWorkflowDefinitionsResponseBody>> {
        const queryParameters: any = {};

        if (requestParameters.batchId !== undefined) {
            queryParameters['batch_id'] = requestParameters.batchId;
        }

        if (requestParameters.workflowType !== undefined) {
            queryParameters['workflow_type'] = requestParameters.workflowType;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.createdAt !== undefined) {
            queryParameters['created_at'] = (requestParameters.createdAt as any).toISOString();
        }

        if (requestParameters.definitionFile !== undefined) {
            queryParameters['definition_file'] = requestParameters.definitionFile;
        }

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.versionNumber !== undefined) {
            queryParameters['version_number'] = requestParameters.versionNumber;
        }

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.startingAfter !== undefined) {
            queryParameters['starting_after'] = requestParameters.startingAfter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/workflow-definitions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWorkflowDefinitionsResponseBodyFromJSON(jsonValue));
    }

    /**
     * list all known workflow definitions submitted to isolateed zone
     * list_workflow_definitions contents
     */
    async contentsListWorkflowDefinitions(requestParameters: ContentsListWorkflowDefinitionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWorkflowDefinitionsResponseBody> {
        const response = await this.contentsListWorkflowDefinitionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recreate all SIPs in a transfer
     * recreate_sips contents
     */
    async contentsRecreateSipsRaw(requestParameters: ContentsRecreateSipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsRecreateSips.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/reprocess`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Recreate all SIPs in a transfer
     * recreate_sips contents
     */
    async contentsRecreateSips(requestParameters: ContentsRecreateSipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsRecreateSipsRaw(requestParameters, initOverrides);
    }

    /**
     * Signal the transfer has been reviewed and rejected
     * reject_transfer contents
     */
    async contentsRejectTransferRaw(requestParameters: ContentsRejectTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsRejectTransfer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/reject`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Signal the transfer has been reviewed and rejected
     * reject_transfer contents
     */
    async contentsRejectTransfer(requestParameters: ContentsRejectTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsRejectTransferRaw(requestParameters, initOverrides);
    }

    /**
     * Resubmit all SIPs in a transfer
     * resubmit_transfer contents
     */
    async contentsResubmitTransferRaw(requestParameters: ContentsResubmitTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsResubmitTransfer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/resubmit`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resubmit all SIPs in a transfer
     * resubmit_transfer contents
     */
    async contentsResubmitTransfer(requestParameters: ContentsResubmitTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsResubmitTransferRaw(requestParameters, initOverrides);
    }

    /**
     * Signal the transfer has been reviewed and should be resubmitted to the SDPS.
     * retry_transfer contents
     */
    async contentsRetryTransferRaw(requestParameters: ContentsRetryTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsRetryTransfer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/retry`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Signal the transfer has been reviewed and should be resubmitted to the SDPS.
     * retry_transfer contents
     */
    async contentsRetryTransfer(requestParameters: ContentsRetryTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contentsRetryTransferRaw(requestParameters, initOverrides);
    }

    /**
     * Show batch by ID
     * show_batch contents
     */
    async contentsShowBatchRaw(requestParameters: ContentsShowBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Batch>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsShowBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/batches/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchFromJSON(jsonValue));
    }

    /**
     * Show batch by ID
     * show_batch contents
     */
    async contentsShowBatch(requestParameters: ContentsShowBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Batch> {
        const response = await this.contentsShowBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Show transfer by ID
     * show_transfer contents
     */
    async contentsShowTransferRaw(requestParameters: ContentsShowTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Transfer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsShowTransfer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransferFromJSON(jsonValue));
    }

    /**
     * Show transfer by ID
     * show_transfer contents
     */
    async contentsShowTransfer(requestParameters: ContentsShowTransferRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Transfer> {
        const response = await this.contentsShowTransferRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Show note for a transfer
     * show_transfer_note contents
     */
    async contentsShowTransferNoteRaw(requestParameters: ContentsShowTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TransferNote>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentsShowTransferNote.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_header_Authorization", []);
        }

        const response = await this.request({
            path: `/contents/transfers/{id}/note`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TransferNoteFromJSON(jsonValue));
    }

    /**
     * Show note for a transfer
     * show_transfer_note contents
     */
    async contentsShowTransferNote(requestParameters: ContentsShowTransferNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TransferNote> {
        const response = await this.contentsShowTransferNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ContentsAuditActivityEnum = {
    Login: 'Login',
    Logout: 'Logout',
    TransferReportUnknown: 'Transfer Report Unknown',
    TransferReportSummary: 'Transfer Report Summary'
} as const;
export type ContentsAuditActivityEnum = typeof ContentsAuditActivityEnum[keyof typeof ContentsAuditActivityEnum];
/**
 * @export
 */
export const ContentsDownloadTransferReportReportTypeEnum = {
    Summary: 'summary',
    Appendix: 'appendix'
} as const;
export type ContentsDownloadTransferReportReportTypeEnum = typeof ContentsDownloadTransferReportReportTypeEnum[keyof typeof ContentsDownloadTransferReportReportTypeEnum];
/**
 * @export
 */
export const ContentsListBatchesContentTypeEnum = {
    Transfer: 'Transfer',
    Sip: 'SIP',
    Aip: 'AIP',
    Dip: 'DIP',
    PackageStatusUpdates: 'Package Status Updates',
    WorkflowDefinition: 'Workflow Definition',
    DisseminationRequest: 'Dissemination Request',
    ReingestRequest: 'Reingest Request',
    FileFormatCategoryChanges: 'File Format Category Changes',
    Unknown: 'Unknown',
    SystemConfigurationUpdates: 'System Configuration Updates'
} as const;
export type ContentsListBatchesContentTypeEnum = typeof ContentsListBatchesContentTypeEnum[keyof typeof ContentsListBatchesContentTypeEnum];
/**
 * @export
 */
export const ContentsListBatchesStatusEnum = {
    Received: 'Received',
    Accepted: 'Accepted',
    Failed: 'Failed',
    Identified: 'Identified'
} as const;
export type ContentsListBatchesStatusEnum = typeof ContentsListBatchesStatusEnum[keyof typeof ContentsListBatchesStatusEnum];
/**
 * @export
 */
export const ContentsListBatchesOrderingEnum = {
    Id: 'id',
    ContentType: 'content_type',
    TimeStarted: 'time_started',
    StatusUpdatedAt: 'status_updated_at',
    Status: 'status',
    DId: 'd-id',
    DContentType: 'd-content_type',
    DTimeStarted: 'd-time_started',
    DStatusUpdatedAt: 'd-status_updated_at',
    DStatus: 'd-status'
} as const;
export type ContentsListBatchesOrderingEnum = typeof ContentsListBatchesOrderingEnum[keyof typeof ContentsListBatchesOrderingEnum];
/**
 * @export
 */
export const ContentsListDipsSecurityGradingEnum = {
    Confidential: 'Confidential',
    ConfidentialCloudEligible: 'Confidential (Cloud-Eligible)',
    Restricted: 'Restricted',
    OfficialClosed: 'Official (Closed)',
    OfficialOpen: 'Official (Open)',
    Secret: 'Secret',
    Unclassified: 'Unclassified',
    Undefined: 'Undefined'
} as const;
export type ContentsListDipsSecurityGradingEnum = typeof ContentsListDipsSecurityGradingEnum[keyof typeof ContentsListDipsSecurityGradingEnum];
/**
 * @export
 */
export const ContentsListDipsSensitivityClassificationEnum = {
    Undefined: 'Undefined',
    NonSensitive: 'Non-Sensitive',
    SensitiveNormal: 'Sensitive Normal',
    SensitiveHigh: 'Sensitive High'
} as const;
export type ContentsListDipsSensitivityClassificationEnum = typeof ContentsListDipsSensitivityClassificationEnum[keyof typeof ContentsListDipsSensitivityClassificationEnum];
/**
 * @export
 */
export const ContentsListDisseminationRequestsPackageTypeEnum = {
    Aip: 'AIP',
    Dip: 'DIP'
} as const;
export type ContentsListDisseminationRequestsPackageTypeEnum = typeof ContentsListDisseminationRequestsPackageTypeEnum[keyof typeof ContentsListDisseminationRequestsPackageTypeEnum];
/**
 * @export
 */
export const ContentsListDisseminationRequestsStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type ContentsListDisseminationRequestsStatusEnum = typeof ContentsListDisseminationRequestsStatusEnum[keyof typeof ContentsListDisseminationRequestsStatusEnum];
/**
 * @export
 */
export const ContentsListFileformatCategoryChangesStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type ContentsListFileformatCategoryChangesStatusEnum = typeof ContentsListFileformatCategoryChangesStatusEnum[keyof typeof ContentsListFileformatCategoryChangesStatusEnum];
/**
 * @export
 */
export const ContentsListPackageStatusUpdatesStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type ContentsListPackageStatusUpdatesStatusEnum = typeof ContentsListPackageStatusUpdatesStatusEnum[keyof typeof ContentsListPackageStatusUpdatesStatusEnum];
/**
 * @export
 */
export const ContentsListReingestRequestsPackageTypeEnum = {
    Aip: 'AIP',
    Dip: 'DIP'
} as const;
export type ContentsListReingestRequestsPackageTypeEnum = typeof ContentsListReingestRequestsPackageTypeEnum[keyof typeof ContentsListReingestRequestsPackageTypeEnum];
/**
 * @export
 */
export const ContentsListReingestRequestsStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type ContentsListReingestRequestsStatusEnum = typeof ContentsListReingestRequestsStatusEnum[keyof typeof ContentsListReingestRequestsStatusEnum];
/**
 * @export
 */
export const ContentsListTransferExceptionsTypeEnum = {
    Warning: 'Warning',
    CriticalError: 'Critical Error',
    NonCriticalError: 'Non-critical Error'
} as const;
export type ContentsListTransferExceptionsTypeEnum = typeof ContentsListTransferExceptionsTypeEnum[keyof typeof ContentsListTransferExceptionsTypeEnum];
/**
 * @export
 */
export const ContentsListTransferPackagesPackageTypeEnum = {
    Aip: 'AIP',
    Dip: 'DIP'
} as const;
export type ContentsListTransferPackagesPackageTypeEnum = typeof ContentsListTransferPackagesPackageTypeEnum[keyof typeof ContentsListTransferPackagesPackageTypeEnum];
/**
 * @export
 */
export const ContentsListTransferPackagesStatusEnum = {
    Created: 'Created',
    Validated: 'Validated',
    Failed: 'Failed',
    SentToStorage: 'Sent to Storage',
    Stored: 'Stored',
    DisseminationRequested: 'Dissemination Requested',
    Disseminated: 'Disseminated',
    ReingestRequested: 'Reingest Requested',
    PreProcessing: 'Pre-Processing',
    ReadyForIngest: 'Ready for Ingest',
    Ingesting: 'Ingesting',
    PendingReview: 'Pending Review',
    Rejected: 'Rejected'
} as const;
export type ContentsListTransferPackagesStatusEnum = typeof ContentsListTransferPackagesStatusEnum[keyof typeof ContentsListTransferPackagesStatusEnum];
/**
 * @export
 */
export const ContentsListTransferSipsStatusEnum = {
    Created: 'Created',
    Failed: 'Failed',
    Ingesting: 'Ingesting',
    PackagesCreated: 'Packages Created',
    Rejected: 'Rejected',
    Stored: 'Stored'
} as const;
export type ContentsListTransferSipsStatusEnum = typeof ContentsListTransferSipsStatusEnum[keyof typeof ContentsListTransferSipsStatusEnum];
/**
 * @export
 */
export const ContentsListTransferSipsOrderingEnum = {
    SipId: 'sip_id',
    Name: 'name',
    Status: 'status',
    StatusUpdatedAt: 'status_updated_at',
    DSipId: 'd-sip_id',
    DName: 'd-name',
    DStatus: 'd-status',
    DStatusUpdatedAt: 'd-status_updated_at'
} as const;
export type ContentsListTransferSipsOrderingEnum = typeof ContentsListTransferSipsOrderingEnum[keyof typeof ContentsListTransferSipsOrderingEnum];
/**
 * @export
 */
export const ContentsListTransfersStatusEnum = {
    Received: 'Received',
    Failed: 'Failed',
    PreProcessing: 'Pre-Processing',
    PendingReview: 'Pending Review',
    Rejected: 'Rejected',
    ReadyForIngest: 'Ready for Ingest',
    Ingesting: 'Ingesting',
    PackagesCreated: 'Packages Created',
    PackagesSentToStorage: 'Packages Sent to Storage',
    Stored: 'Stored',
    ReportCreated: 'Report Created',
    SipCreationFailed: 'SIP Creation Failed'
} as const;
export type ContentsListTransfersStatusEnum = typeof ContentsListTransfersStatusEnum[keyof typeof ContentsListTransfersStatusEnum];
/**
 * @export
 */
export const ContentsListTransfersStructureTypeEnum = {
    EasA: 'EAS A',
    EasB: 'EAS B',
    EasD1: 'EAS D-1',
    Bag: 'Bag'
} as const;
export type ContentsListTransfersStructureTypeEnum = typeof ContentsListTransfersStructureTypeEnum[keyof typeof ContentsListTransfersStructureTypeEnum];
/**
 * @export
 */
export const ContentsListTransfersOrderingEnum = {
    ProcessingStartedAt: 'processing_started_at',
    DProcessingStartedAt: 'd-processing_started_at'
} as const;
export type ContentsListTransfersOrderingEnum = typeof ContentsListTransfersOrderingEnum[keyof typeof ContentsListTransfersOrderingEnum];
/**
 * @export
 */
export const ContentsListWorkflowDefinitionsStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type ContentsListWorkflowDefinitionsStatusEnum = typeof ContentsListWorkflowDefinitionsStatusEnum[keyof typeof ContentsListWorkflowDefinitionsStatusEnum];
